import React, { useEffect } from 'react';
import useData from '../hooks/useData';
import useApp from '../hooks/useApp';
import IconHeartFilled from '../icons/IconHeartFilled';

const ExhibitorListPrint = () => {
	const { exhibitorInfo } = useData();
	const { isCHT, setLanguage } = useApp();

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const lang = urlParams.get('lang');
		setLanguage(lang);
	}, [setLanguage]);

	useEffect(() => {
		setTimeout(() => {
			window.print();
		}, 1000);
	}, []);

	return (
		<div id='ExhibitorListPrint'>
			<div className='panel-heading'>{isCHT ? '廠商名單' : 'Exhibitor List'}</div>
			<div className='panel-body'>

				<div className='exhibitors'>
					<div className='exhibitor'>
						<div className='name heading'>{isCHT ? '廠商名稱' : 'Exhibitor Name'}</div>
						<div className='booth-number heading'>{isCHT ? '攤位號碼' : 'Booth Number'}</div>
						<div className='favourite heading'>{isCHT ? '我的最愛' : 'Favourite'}</div>
					</div>

					{exhibitorInfo.map((exhibitor, index) => {
						const exhibitorName = isCHT ? exhibitor['廠商名稱-中文'] : exhibitor['廠商名稱-英文'];
						const booth = exhibitor['攤位號碼'];
						const isFav = exhibitor.favourite;

						return (
							<div className='exhibitor' key={`exhibitorLinkTableRow${index}`}>
								<div className='name'>{exhibitorName}</div>
								<div className='booth-number'>{booth}</div>
								<div className='favourite'>{isFav ? (<IconHeartFilled />) : null}</div>
							</div>
						)
					})}
				</div>
			</div>
		</div>
	)
}

export default ExhibitorListPrint;